/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { createContext, memo } from "react";
import { useLocation, Redirect } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import SideBar from "./SideBar";
import { Navbar } from "./Navbar";
import AdminContent from "./AdminContent";

export const AdminContext = createContext();

export default memo(() => {
  const { user } = useAuth();
  const { pathname } = useLocation();

  return !user ? (
    <Redirect to={{ pathname: "/auth", state: { pathname } }} />
  ) : (
    <AdminContext.Provider>
      <div id="layout-wrapper">
        <Navbar />
        <SideBar />
        <AdminContent />
      </div>
    </AdminContext.Provider>
  );
});
